import { Component } from '@angular/core';

@Component({
  selector: 'app-view-details-loader',
  templateUrl: './view-details-loader.component.html',
  styleUrls: ['./view-details-loader.component.scss'],
})
export class ViewDetailsLoaderComponent {}
